/* eslint-disable @typescript-eslint/no-explicit-any */
import React from 'react';
import * as Im from 'immutable';
import { Typography } from '@rbx/ui';
import useDetailsSwaggerUIStyles from './DetailsSwaggerUI.styles';

// Combination of a few components from swagger-ui
// https://github.com/swagger-api/swagger-ui/blob/04b9ad7b37f02bce0e1cb8c521e40b68585ccf9f/src/core/components/operations.jsx
// https://github.com/swagger-api/swagger-ui/blob/04b9ad7b37f02bce0e1cb8c521e40b68585ccf9f/src/core/containers/OperationContainer.jsx
const DetailsSwaggerUILayout = ({ getComponent, specSelectors, specActions }: any) => {
  const { classes } = useDetailsSwaggerUIStyles();

  // Get the OperationContainer component from swagger-ui
  const OperationContainer = getComponent('OperationContainer', true);

  // Get the first operation to render
  const taggedOps = specSelectors.taggedOperations();
  if (!taggedOps || taggedOps.size === 0) {
    return <Typography variant='body1'>No tagged operations found</Typography>;
  }

  const operations = taggedOps
    .entrySeq()
    .flatMap(([, tagObj]: [string, any]) => tagObj.get('operations'));

  if (!operations || operations.size === 0) {
    return <Typography variant='body1'>No operations found</Typography>;
  }

  const op = operations.first();
  if (!op || op === undefined) {
    return <Typography variant='body1'>No unresolved operation found</Typography>;
  }

  const path = op.get('path');
  const method = op.get('method');
  const specPath = Im.List(['paths', path, method]);

  // Force a subtree resolution
  if (specSelectors.specResolvedSubtree(specPath.toJS()) === undefined) {
    specActions.requestResolvedSubtree(specPath.toJS());
  }

  // By positioning styles with a wrapper, we ensure that styles specified in the container
  // are more specific and take precedence over default swagger-ui styles
  return (
    <div className={classes.container}>
      <div className='swagger-ui'>
        <OperationContainer specPath={specPath} op={op} path={path} method={method} tag='' />
      </div>
    </div>
  );
};

export default DetailsSwaggerUILayout;
